export function adjustFormat(accNo: string) {
  if (/sp$/.test(accNo.toLowerCase())) {
    accNo = accNo.substring(0, accNo.length - 2);
  }

  return accNo.replace(/^0*/, "");
}
